const RightTriangleIcon = ({ className = '' }) => (
  <svg className={`size-4 fill-blue-500 ${className}`} viewBox="0 0 24 24">
    <path d="M8 5v14l11-7z" />
  </svg>
);

export default RightTriangleIcon;
